export default __webpack_public_path__ + "static/media/section-about.4e4e2b1d.webp";